import variables from 'variables.module.scss';

export const antGlobalTheme = {
  colorPrimary: variables.warningColor,
};
